"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

var _utils = require("../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mutation UpdateVideo($input: VideoInput!, $videoId: String!) {\n    updateVideo(input: $input, videoId: $videoId) {\n      organisationId\n      videoId\n      rejectionFeedback\n      clips {\n        clipId\n        isImage\n        clipStartTime\n        isEmpty\n        duration\n        originalDuration\n        startTime\n        assetId\n        layerIndex\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
/**
 * Playable clip's IDs will change so we need to update them from the response
 */


var updateVideoQuery = (0, _graphqlTag.default)(_templateObject());

var updateVideo = function updateVideo(videoId) {
  return {
    mutation: updateVideoQuery,
    module: 'video',
    buildVariables: function buildVariables(input) {
      var permissions = input.permissions,
          videoInput = _objectWithoutProperties(input, ["permissions"]);

      return {
        input: (0, _utils.buildVideoPayload)(videoInput),
        videoId: videoId
      };
    }
  };
};

var _default = updateVideo;
exports.default = _default;